// extracted by mini-css-extract-plugin
module.exports = {"chart-label":"styles_chart-label__3z6gs","intro-chart":"styles_intro-chart__2vIoM"};